<template>
  <!-- 国内航空首页 -->
  <div class="airIndex" @click="noneShow">
    <div class="banner">
      <!-- <ScrollBox/> -->
    </div>
    <!-- 顶部搜索部分 -->
    <div class="air_centre">
      <div class="condition-box">
        <div>
          <div class="flex-center-start">
            <span
              class="condition_nav cursor"
              :class="{'condition_nav-active':conditionNavActive===1}"
              @click="conditionNavActive = 1,starTwoCity1 = '',endTwoCity1=''"
            >
              <i class="iconfont iconfeiji"></i>国内机票
            </span>
            <span
              class="condition_nav cursor"
              :class="{'condition_nav-active':conditionNavActive===2}"
              @click="conditionNavActive = 2,starCity1 = '',endCity1=''"
            >
              <i class="iconfont iconguojijipiao"></i>港澳台/国际机票
            </span>
          </div>
          <div class="condition">
            <!-- <h2>实时航班查询</h2> -->
            <!-- 选择类型 -->
            <!-- 选择城市日期 -->
            <div class="air-type df">
              <p>航程类型</p>
              <el-radio-group v-model="airType">
                <el-radio :label="1">单程</el-radio>
                <el-radio :label="2">往返</el-radio>
                <!-- <el-radio :label='3' v-show="conditionNavActive===2">多程</el-radio> -->
              </el-radio-group>
            </div>
            <div class="df">
              <div class="select-box">
                <div class="city" v-show="conditionNavActive == 1">
                  <div class="starCity df">
                    <p>出发城市</p>
                    <DomesticTicketAirportSelector class="flight-template" ref="startDomesticTicketAirportSelector" v-model="startAirportParams"></DomesticTicketAirportSelector>
                  </div>
                  <div class="starCity df">
                    <p>目的城市</p>
                    <DomesticTicketAirportSelector class="flight-template" ref="endDomesticTicketAirportSelector" v-model="endAirportParams"></DomesticTicketAirportSelector>
                  </div>
                </div>
                <div class="city" v-if="conditionNavActive == 2">
                  <div class="starCity df">
                    <p>出发城市</p>
                    <el-autocomplete
                      id="starTwoCity"
                      ref="starTwoCity"
                      :debounce="200"
                      v-model="starTwoCity1"
                      clearable
                      size="medium"
                      :fetch-suggestions="(val,cb)=>querySearchForeign(val,cb,'starTwoCity1')"
                      placeholder="中文/拼音/三字码"
                      :trigger-on-focus="false"
                      @select="getstarTwoCity"
                      @focus="CityFocus('starTwoCity')"
                    >
                      <template slot-scope="{ item }">
                        <div class="name">{{ item.name }} ({{item.code}})</div>
                      </template>
                    </el-autocomplete>
                    <!-- 字母城市 -->
                    <div class="cityList" v-if="starTwoList">
                      <h6>支持中文/拼音/三字码/简拼</h6>
                      <!-- 热搜头部 -->
                      <div class="cityList-head df">
                        <span
                          v-for="(item, index) in cityListH"
                          :key="index"
                          :class="{'active': cityListHShow === index}"
                          @click.stop="cityListHShow = index"
                        >{{item}}</span>
                      </div>
                      <div class="cityList-c scrollbar">
                        <!-- 热门城市 -->
                        <div v-if="cityListHShow === 0 " class="hotCity">
                          <div class="HotCity">
                            <span
                              v-for="(item,index) in internationalCityHotCity"
                              :key="index"
                              @click="getClickCity(item,'starTwoCity')"
                            >{{item.name}}</span>
                          </div>
                        </div>
                        <div v-else class="AZCity">
                          <div v-for="(item,key,index) in internationalCity" :key="index">
                            <div
                              v-if="cityListH[cityListHShow].toLowerCase().indexOf(key.toLowerCase()) !== -1"
                              class="AZCityList df"
                            >
                              <div>
                                <p>{{key}}</p>
                              </div>
                              <div>
                                <span
                                  v-for="(items,indexs) in item"
                                  :key="indexs"
                                  @click="getClickCity(items,'starTwoCity')"
                                >{{items.name}}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="starCity df">
                    <p>目的城市</p>
                    <el-autocomplete
                      id="endTwoCity"
                      ref="endTwoCity"
                      :debounce="200"
                      size="medium"
                      v-model="endTwoCity1"
                      clearable
                      :fetch-suggestions="(val,cb)=>querySearchForeign(val,cb,'endTwoCity1')"
                      placeholder="中文/拼音/三字码"
                      :trigger-on-focus="false"
                      @select="getendTwoCity"
                      @focus="CityFocus('endTwoCity')"
                    >
                      <template slot-scope="{ item }">
                        <div class="name">{{ item.name }} ({{item.code}})</div>
                      </template>
                    </el-autocomplete>
                    <div class="cityList" v-if="EndTwoList">
                      <h6>支持中文/拼音/三字码/简拼</h6>
                      <!-- 热搜头部 -->
                      <div class="cityList-head df">
                        <span
                          v-for="(item, index) in cityListH"
                          :key="index"
                          :class="{'active': cityListHShow === index}"
                          @click.stop="cityListHShow = index"
                        >{{item}}</span>
                      </div>
                      <div class="cityList-c scrollbar">
                        <!-- 热门城市 -->
                        <div v-if="cityListHShow ===0 " class="hotCity">
                          <div class="HotCity">
                            <span
                              v-for="(item,index) in internationalCityHotCity"
                              :key="index"
                              @click="getClickCity(item,'endTwoCity')"
                            >{{item.name}}</span>
                          </div>
                        </div>
                        <div v-else class="AZCity">
                          <div v-for="(item,key,index) in internationalCity" :key="index">
                            <div
                              v-if="cityListH[cityListHShow].toLowerCase().indexOf(key.toLowerCase()) !== -1"
                              class="AZCityList df"
                            >
                              <div>
                                <p>{{key}}</p>
                              </div>
                              <div>
                                <span
                                  v-for="(items,indexs) in item"
                                  :key="indexs"
                                  @click="getClickCity(items,'endTwoCity')"
                                >{{items.name}}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="time-box">
                  <div class="time df">
                    <p v-if="airType !==3">出发时间</p>
                    <p v-else>去程时间</p>
                    <el-date-picker
                      v-model="time1"
                      align="right"
                      size="medium"
                      type="date"
                      ref="time1"
                      placeholder="选择日期"
                      value-format="timestamp"
                      :picker-options="pickerOptions"
                    ></el-date-picker>
                  </div>
                  <div class="time df">
                    <p class="demonstration" style="text-align:left" v-if="airType !==3">返回时间</p>
                    <p class="demonstration" v-else>回程时间</p>
                    <el-date-picker
                      v-model="time2"
                      :disabled="time2Show"
                      type="date"
                      :default-value="time1||''"
                      size="medium"
                      ref="time2"
                      value-format="timestamp"
                      :picker-options="pickerOptions2"
                      placeholder="选择日期"
                    ></el-date-picker>
                  </div>
                </div>
                <div class="air-ClassType2 df" v-show="conditionNavActive===1">
                  <div class="df">
                    <p>舱位等级</p>
                    <el-select v-model="ClassType" size="medium">
                      <el-option
                        v-for="(item,index) in ClassTypeList"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                  <div class="df">
                    <p>航空公司</p>
                    <!-- <el-select v-model="airlines">
                      <el-option
                        v-for="(item,index) in airlinesList"
                        :key="index"
                        :label="item.airCompanyName"
                        :value="item.airlineCode"
                      ></el-option>
                    </el-select>-->
                    <air-line-box :data="airlinesList" @selectItem="selectItem" size="medium"></air-line-box>
                  </div>
                </div>
                <div class="air-ClassType2 passenger-air df" v-show="conditionNavActive===1">
                  <p>乘客类型</p>
                  <div class="el-checkbox-group">
                    <el-radio v-model="psgType" :label="1" style="margin-right: 10px;">成人</el-radio>
                    <el-radio v-model="psgType" :label="2" style="margin-right: 10px;">儿童</el-radio>
                    <el-radio
                      v-model="psgType"
                      :label="3"
                      style="margin-right: 10px;"
                      v-show="airType==1"
                    >成人+儿童</el-radio>
                  </div>
                </div>
                <div
                  class="input_space"
                  v-show="conditionNavActive===2"
                  style="margin:10px 0 20px 0;"
                >
                  <div>
                    <div style="width:100px " class="text_space">
                      <p>舱位等级</p>
                    </div>
                    <div>
                      <el-select
                        v-model="international.rank"
                        placeholder="请选择舱位等级"
                        clearable
                        size="medium"
                      >
                        <el-option
                          v-for="item in international.rankList"
                          :key="item.label"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </div>
                  </div>
                  <div>
                    <div style="width:100px" class="text_space">
                      <p>航空公司</p>
                    </div>
                    <div class="air-company">
                      <air-line-box :data="internationalAirList" @selectItem="selectItem"></air-line-box>
                    </div>
                  </div>
                </div>
                <div class="flex-center-start fare" v-show="conditionNavActive===2">
                  <div style="width:100px">
                    <p>乘客类型</p>
                  </div>
                  <div class="fare_input">
                    <el-select
                      v-model="international.adult"
                      placeholder="请选择成人"
                      clearable
                      size="medium"
                    >
                      <el-option
                        v-for="item in international.adultList"
                        :key="item.label"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                    <el-select
                      v-model="international.child"
                      placeholder="请选择儿童"
                      clearable
                      size="medium"
                    >
                      <el-option
                        v-for="item in international.childList"
                        :key="item.label"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                    <el-select
                      v-model="international.baby"
                      placeholder="请选择婴儿"
                      clearable
                      size="medium"
                    >
                      <el-option
                        v-for="item in international.babyList"
                        :key="item.label"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
            </div>
            <button @click="search">搜索航班</button>
            <div class="condition_img">
              <div>
                <div class="condition_title">
                  <p>公告</p>
                </div>
                <ul class="condition_list scrollbar">
                  <li
                    class="flex-center-end"
                    v-for="(announ,index) in announcementList"
                    :key="index"
                  >
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="announ.val"
                      placement="top-start"
                    >
                      <span @click="goAnnoun(announ.url)">{{announ.val}}</span>
                    </el-tooltip>
                    <span>{{announ.date}}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="pnr">
      <h2>
        <i class="iconfont icondiannao"></i>PNR导入
      </h2>
      <div class="pnr_contont">
        <div class="pnr_left">
          <textarea v-model="PNRtext"></textarea>
          <p>
            <button class="PNRorder cursor">导入下单</button>
            <button @click="PNRtext=''" class="cursor">清空</button>
          </p>
        </div>
        <div class="pnr_right">
          <h2>
            注意事项
            <i>?</i>
          </h2>
          <p>
            1.导入PNR之前请检查PNR内容
            <span>（姓名/舱位/航段/证件/联系方式/特殊事项等）</span>真实准确，如问题的PNR导致无法出票本公司盖不负责。
          </p>
          <p>2.请核实航段状态为可预订状态，如已取消或NO位等造成无法出票结果，本公司概不负责。</p>
          <p>3.请确保PNR里的证件信息齐全的，根据民航局和航司的文件要求，订座PNR需完整录入CTCM和CTCT指令，其中CTCM按照旅客人数输入对应数量的手机号，且号码需与旅客相匹配。如不按规定操作，将会导致航司下发相关罚单,请采购分销务必谨慎检查处理。</p>
          <p>4请确保导入平台的PNR中所含航段是通过正常途径获得，任何通过非法手段获取低舱位或违反航司机票使用规则（例：弃程、借关等）行为导致的航司ADM罚单，平台将保留追责的权利。</p>
          <p>5.生成订单时，您须保证录入的乘客信息准确、真实、有效；下单成功后不可随意修改PNR中的任何信息记录。</p>
          <p>6.导单前请您充分了解各个航空公司的订票规则及对应文件，以避免因特殊行程、旅客身份、航司特殊规则等可能对客票使用及售后产生影响的情况。</p>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
  // 机票选择组件
  import DomesticTicketAirportSelector from 'yinzhilv-js-sdk/frontend/common-project/component/yinzhilv/domestic-ticket-airport-selector/1.0.0/index.vue';
// 城市列表查询
const citys = require(`../../../../../lib/data-service/flight/flight_domestic_citys`);
import { internationalCity } from "@/lib/data-service/flight/fligthInternational";
// 国内航空公司查询
const airlines = require(`../../../../../lib/data-service/flight/flight_domestic_airlines`);
// 国内航班列表查询
const flights = require(`../../../../../lib/data-service/flight/flight_domestic_flights`);
import airLineBox from "./../../components/airLine";
import { internationalAirLines } from "@/lib/data-service/flight/fligthInternational";
import noticeList from "./../../components/notice";
const _ = require(`underscore`);
  // 获取公告
  import get_flight_notice_list from "@/lib/data-service/yinzhilv-temporary-storage-system/get_flight_notice_list";

export default {
  data() {
    return {
      startAirportParams: null,
      endAirportParams: null,

      pickerOptions: this.setEndTime1(),
      // announcementList: noticeList,
      announcementList: [],
      airType: 1, // 航程类型
      PNRtext: "",
      conditionNavActive: 1,
      airTypeShow: true,
      pickerOptions2: this.setEndTime(), //  返回时间
      time1: null, //  出发时间
      time2: null, //  返回时间
      time2Show: true, // 返回时间是否可用
      timeRoll: 1569772800000, //滚动条时间
      starCity: "", // 出发城市
      starCity1: "", // 展示出发城市
      starTwoCity: "", // 第二出发城市
      starTwoCity1: "", // 第二展示出发城市
      endCity: "", // 目的城市
      endCity1: "", // 展示目的城市
      endTwoCity: "", // 第二目的城市
      endTwoCity1: "", // 第二展示目的城市
      cityList: [], // 城市字母列表
      restaurants: [], // 所有城市机场列表
      cityListH: ["热门", "ABCD", "EFGH", "JKLM", "NOPQRS", "TUVWX", "YZ"], // 热门列表
      international: {
        adult: 1,
        adultList: [
          { value: 1, label: "成人1" },
          { value: 2, label: "成人2" },
          { value: 3, label: "成人3" },
          { value: 4, label: "成人4" },
          { value: 5, label: "成人5" },
          { value: 6, label: "成人6" },
          { value: 7, label: "成人7" },
          { value: 8, label: "成人8" },
          { value: 9, label: "成人9" }
        ],
        childList: [
          { value: 1, label: "儿童1" },
          { value: 2, label: "儿童2" },
          { value: 3, label: "儿童3" },
          { value: 4, label: "儿童4" },
          { value: 5, label: "儿童5" },
          { value: 6, label: "儿童6" },
          { value: 7, label: "儿童7" },
          { value: 8, label: "儿童8" },
          { value: 9, label: "儿童9" }
        ],
        babyList: [
          { value: 1, label: "婴儿1" },
          { value: 2, label: "婴儿2" },
          { value: 3, label: "婴儿3" },
          { value: 4, label: "婴儿4" }
        ],
        rankList: [
          { value: 1, label: "头等舱" },
          { value: 2, label: "公务舱" },
          { value: 3, label: "经济舱" }
        ],
        rank: 3
      }, //国际航空
      HotCity: [], //  热门城市列表
      cityListHShow: 0, //  热门列表index
      starList: false, //  出发城市列表显示
      EndList: false, //  目的城市列表显示
      starTwoList: false, //  出发城市列表显示
      EndTwoList: false, //  目的城市列表显示
      ClassType: 0, //  舱位选择
      ClassTypeList: [
        //  舱位列表
        {
          value: 0,
          label: "不限"
        },
        {
          value: 1,
          label: "头等舱"
        },
        {
          value: 2,
          label: "公务舱"
        },
        {
          value: 3,
          label: "经济舱"
        }
      ],
      psgType: 1, //  乘机人类型
      airlines: "", //  航司
      airlinesList: [
        //  航司列表
        {
          airlineCode: "",
          airCompanyName: "不限"
        }
      ],
      internationalAirList: [],
      timeIndex: 0, // 已选的class
      flightsList: [], // 航班列表
      flightsIndex: 0, //  当前展示的列表
      flightsShow: false, // 是否展示
      reserveType: "预定", // 按钮状态
      params: {}, // 搜索传参
      internationalCity: [],
      internationalCityHotCity: [],
      internationalCitys: []
    };
  },
  components: { airLineBox, DomesticTicketAirportSelector },
  methods: {
    // 获取公告
    getNoticeList() {
      get_flight_notice_list().then(res => {
        this.announcementList = res.data.allFlightNoticeLists;
      })
    },
    // 日期选择
    setEndTime() {
      let _this = this;
      return {
        disabledDate: time => {
          if (_this.time1) {
            return time.getTime() < _this.time1;
          } else {
            return time.getTime() < Date.now() - 1000 * 3600 * 24;
          }
        }
      };
    },
    goAnnoun(val) {
      window.open(val);
    },
    setEndTime1() {
      let _this = this;
      return {
        disabledDate: time => {
          if (_this.time2 && this.airType === 2) {
            return (
              time.getTime() > _this.time2 ||
              time.getTime() < Date.now() - 1000 * 3600
            );
          } else {
            return time.getTime() < Date.now() - 1000 * 3600 * 24;
          }
        }
      };
    },
    querySearch(queryString, cb, name) {
      if (!queryString) return;
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      results.length === 0 ? (this[name] = "") : "";
      cb(results);
    },
    querySearchForeign(queryString, cb, name) {
      if (!queryString) return;
      var restaurants = this.internationalCitys;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      results.length === 0 ? (this[name] = "") : "";
      cb(results);
    },
    createFilter(queryString) {
      let pattern2 = new RegExp("[A-Za-z]+");
      if (pattern2.test(queryString)) {
        return restaurant => {
          if (restaurant.spell && restaurant.code) {
            if (
              restaurant.spell
                .toUpperCase()
                .indexOf(queryString.toUpperCase()) != -1
            ) {
              return restaurant;
            } else if (
              restaurant.code.indexOf(queryString.toUpperCase()) != -1
            ) {
              return restaurant;
            }
          } else {
            return "";
          }
        };
      } else {
        return restaurant => {
          if (restaurant.cityName.indexOf(queryString) !== -1) {
            return restaurant;
          } else {
            return "";
          }
        };
      }
    },

    // 城市转换
    transitionCity() {
      let city = this.starCity;
      this.starCity = this.endCity;
      this.endCity = city;
      let city1 = this.starCity1;
      this.starCity1 = this.endCity1;
      this.endCity1 = city1;
    },
    transitionCity2() {
      let city = this.starTwoCity;
      this.starTwoCity = this.endTwoCity;
      this.endTwoCity = city;
      let city1 = this.starTwoCity1;
      this.starTwoCity1 = this.endTwoCity1;
      this.endTwoCity1 = city1;
    },
    ransitionCity2() {
      let city = this.starTwoCity;
      this.starTwoCity = this.endTwoCity;
      this.endTwoCity = city;
      let city1 = this.starTwoCity1;
      this.starTwoCity1 = this.endTwoCity1;
      this.endTwoCity1 = city1;
    },
    // 获取出发城市
    getstarCity(item) {
      this.starCity = item.airports
        ? item.code
        : item.cityCode
          ? item.cityCode
          : item.code;
      this.starCity1 = item.name + "(" + item.code + ")";
      // console.log(item, this.starCity);
    },
    getstarTwoCity(item) {
      this.starTwoCity = item.airports
        ? item.code
        : item.cityCode
          ? item.cityCode
          : item.code;
      this.starTwoCity1 = item.name + "(" + item.code + ")";
      console.log(item);
    },
    // 获取目的城市
    getendCity(item) {
      this.endCity = item.airports
        ? item.code
        : item.cityCode
          ? item.cityCode
          : item.code;
      this.endCity1 = item.name + "(" + item.code + ")";
      console.log(item);
    },
    getendTwoCity(item) {
      this.endTwoCity = item.airports
        ? item.code
        : item.cityCode
          ? item.cityCode
          : item.code;
      this.endTwoCity1 = item.name + "(" + item.code + ")";
      console.log(item);
    },
    // 获取点击的城市
    getClickCity(item, data) {
      if (data === "starCity") {
        this.starCity = item.airports
          ? item.code
          : item.cityCode
            ? item.cityCode
            : item.code;
        this.starCity1 = item.name + "(" + item.code + ")";
        this.starList = false;
        !this.endCity1 ? this.$refs.endCity1.focus() : "";
      }
      if (data === "endCity") {
        this.endCity = item.airports
          ? item.code
          : item.cityCode
            ? item.cityCode
            : item.code;
        this.endCity1 = item.name + "(" + item.code + ")";
        this.EndList = false;
      }
      if (data === "starTwoCity") {
        this.starTwoCity = item.airports
          ? item.code
          : item.cityCode
            ? item.cityCode
            : item.code;
        this.starTwoCity1 = item.name + "(" + item.code + ")";
        this.starTwoList = false;
      }
      if (data === "endTwoCity") {
        this.endTwoCity = item.airports
          ? item.code
          : item.cityCode
            ? item.cityCode
            : item.code;
        this.endTwoCity1 = item.name + "(" + item.code + ")";
        this.EndTwoList = false;
      }
    },
    // 获取焦点显示热门的城市
    CityFocus(data) {
      if (this.starCity1 === "" && data === "starCity") {
        this.starList = true;
        this.EndList = false;
        this.starTwoList = false;
        this.EndTwoList = false;
      }
      if (this.endCity1 === "" && data === "endCity") {
        this.starList = false;
        this.EndList = true;
        this.starTwoList = false;
        this.EndTwoList = false;
      }
      if (this.starTwoCity1 === "" && data === "starTwoCity") {
        this.starList = false;
        this.EndList = false;
        this.starTwoList = true;
        this.EndTwoList = false;
      }
      if (this.endTwoCity1 === "" && data === "endTwoCity") {
        this.starList = false;
        this.EndList = false;
        this.starTwoList = false;
        this.EndTwoList = true;
      }
    },
    noneShow() {
      let Starfocus = document.getElementById("starCity");
      let endCity = document.getElementById("endCity");
      let StarTwofocus = document.getElementById("starTwoCity");
      let endTwoCity = document.getElementById("endTwoCity");
      if (StarTwofocus !== document.activeElement) {
        this.starTwoList = false;
      }
      if (endTwoCity !== document.activeElement) {
        this.EndTwoList = false;
      }
      if (Starfocus !== document.activeElement) {
        this.starList = false;
      }
      if (endCity !== document.activeElement) {
        this.EndList = false;
      }
    },
    // 阻止事件冒泡
    stop() {},
    selectItem(val) {
      this.airlines = val;
    },
    // 获取航司列表
    getAirlines() {
      airlines({ pageSize: 10000 })
        .then(data => {
          let airlinesList = [
            ...this.airlinesList,
            ...data.pageResult.pageData
          ];
          airlinesList.map(item => {
            item.value = "(" + item.airlineCode + ")" + item.airCompanyName;
          });
          this.airlinesList = airlinesList;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getInternationalAirlines() {
      internationalAirLines().then(data => {
        // console.log(data)
        let airlinesList = [
          ...this.internationalAirList,
          ...data.pageResult.pageData
        ];
        airlinesList.map(item => {
          item.value = "(" + item.airlineCode + ")" + item.airCompanyName;
        });
        this.internationalAirList = airlinesList;
      });
    },
    // 获取城市接口
    loadAllCity() {
      citys().then(res => {
        let restaurants = [...res.citys];
        let cityList = [];
        for (let i = 0; i < res.citys.length; i++) {
          if (res.citys[i].airports === false) {
            cityList.push(res.citys[i]);
          }
          if (
            res.citys[i].isHot === "Y" &&
            this.HotCity.length < 23 &&
            res.citys[i].airports === false
          ) {
            this.HotCity.push(res.citys[i]);
          }
        }
        this.cityList = _.chain(cityList)
          .groupBy(function(m) {
            return m.initial;
          })
          .value();
        this.restaurants = this.setCityName(restaurants, cityList);
      });
    },
    setCityName(restaurants, cityList) {
      let airList = restaurants.filter(item => {
        item.cityName = item.name;
        return item.airports;
      });
      airList.map(item => {
        cityList.map(sitem => {
          if (item.spell === sitem.spell) {
            item.cityName = sitem.name;
          }
        });
      });
      return restaurants;
    },

    // 获取城市接口
    async loadAllInternationalCity() {
      if (this.internationalCity.length != 0) return;
      internationalCity().then(res => {
        let internationalCitys = res.citys;
        let cityList = [];
        for (let i = 0; i < res.citys.length; i++) {
          if (res.citys[i].airports === false) {
            cityList.push(res.citys[i]);
          }
          if (
            res.citys[i].isHot === "Y" &&
            this.HotCity.length < 23 &&
            res.citys[i].airports === false
          ) {
            this.internationalCityHotCity.push(res.citys[i]);
          }
        }
        this.internationalCity = _.chain(cityList)
          .groupBy(function(m) {
            return m.initial;
          })
          .value();
        this.internationalCitys = this.setCityName(
          internationalCitys,
          cityList
        );
      });
    },
    // 搜索航班列表
    search() {
      this.$router.push({
        name: 'login',
      });
      return; 
      this.loading = true;
      this.airTypeShow = true;

      // this.timeRoll = this.time1;
      let params = {
        airType: this.airType, // 航程类型// 航程类型
        time1: this.time1, //  出发时间
        time2: this.time2, //  返回时间
        time2Show: this.time2Show, // 返回时间是否可用
        // timeRoll: this.timeRoll, //滚动条时间
        psgType: this.psgType, //  乘机人类型
        ClassType: this.ClassType, //舱位等级
        airlines: this.airlines //航空公司
      };
      if (this.conditionNavActive == 1) {
        params = Object.assign({}, params, {
          starCity: this.starCity,
          starCity1: this.starCity1,
          endCity: this.endCity,
          endCity1: this.endCity1
        });
        if (!this.starCity1) {
          this.starCity1 ? (this.starCity1 = "") : "";
          this.$refs.starCity1.focus();
          return;
        }
        if (!this.endCity1) {
          this.endCity1 ? (this.endCity1 = "") : "";
          this.$refs.endCity1.focus();
          return;
        }
        if (this.starCity1 == this.endCity1) {
          this.endCity1 = "";
          return;
        }
      }
      if (!this.time1) {
        this.$refs.time1.focus();
        return;
      }
      if (!this.time2 && this.airType === 2) {
        this.$refs.time2.focus();
        return;
      }
      if (this.conditionNavActive === 2) {
        params = Object.assign({}, params, {
          starCity: this.starTwoCity,
          starCity1: this.starTwoCity1,
          endCity: this.endTwoCity,
          endCity1: this.endTwoCity1
        });
        if (!this.starTwoCity1) {
          this.starTwoCity1 ? (this.starTwoCity1 = "") : "";
          this.$refs.starTwoCity.focus();
          return;
        }
        if (!this.endTwoCity1) {
          this.endTwoCity1 ? (this.endTwoCity1 = "") : "";
          this.$refs.endTwoCity.focus();
          return;
        }

        if (this.international.baby && !this.international.adult) {
          return this.$message({ type: "warning", message: "请选择成人" });
        }
        if (
          !this.international.baby &&
          !this.international.adult &&
          !this.international.child
        ) {
          return this.$message({ type: "warning", message: "请选择乘客人数" });
        }
        if (!this.international.rank) {
          return this.$message({ type: "warning", message: "请选择舱位等级" });
        }
        let people;
        let list = this.international;
        list.adult ? (params.adultCount = list.adult) : "";
        list.child ? (params.childCount = list.child) : "";
        list.baby ? (params.babyCount = list.baby) : "";
        people =
          (params.adultCount || 0) +
          (params.childCount || 0) +
          (params.babyCount || 0);
        if (people > 9)
          return this.$message({
            type: "warning",
            message: "最大乘客数量为9人,请重新选择！"
          });
        params.ClassType = this.international.rank;
        return this.$router.push({
          name: "international-air-list",
          query: {
            airdata: JSON.stringify(params)
          }
        });
      }

      this.params = params;
      console.log(this.params);
      if (params.time1 && params.starCity && params.endCity) {
        this.$router.push({
          name: "机票搜索结果",
          query: {
            airdata: JSON.stringify(this.params)
          }
        });
      } else {
        this.$router.push({
          name: "机票搜索结果"
        });
      }
    },
    detectionCity() {
      let arrCity = [];
      for (let i in this.cityList) {
        arrCity.push(...this.cityList[i]);
      }
      let code = arrCity.map(item => {
        return item.code;
      });
      if (code.includes(this.starTwoCity) && code.includes(this.endTwoCity)) {
        this.conditionNavActive = 1;
        this.starCity = this.starTwoCity;
        this.starCity1 = this.starTwoCity1;
        this.endCity = this.endTwoCity;
        this.endCity1 = this.endTwoCity1;
        let cityInfo = [
          "starTwoCity",
          "starTwoCity1",
          "endTwoCity",
          "endTwoCity1"
        ];
        cityInfo.map(name => (this[name] = ""));
      }
    }
  },
  watch: {
    airType() {
      if (this.airType === 1) {
        this.time2Show = true;
      } else {
        this.time2Show = false;
      }
      if (this.airType === 2 && this.time1 > this.time2) {
        this.time2 = null;
      }
      this.airTypeShow = false;
      this.itemOne = [];
    },
    // 出发城市1
    starCity1() {
      let Starfocus = document.getElementById("starCity");
      if (this.starCity1 !== "") {
        this.starList = false;
      }
      if (Starfocus === document.activeElement && this.starCity1 === "") {
        this.starList = true;
      }
    },
    // 目的城市1
    endCity1() {
      let endCity = document.getElementById("endCity");
      if (this.endCity1 !== "") {
        this.EndList = false;
      }
      if (endCity === document.activeElement && this.endCity1 === "") {
        this.EndList = true;
      }
    },
    // 出发城市2
    starTwoCity1() {
      let Starfocus = document.getElementById("starTwoCity");
      if (this.starTwoCity1 !== "") {
        this.starTwoList = false;
        this.endTwoCity1 ? this.detectionCity() : "";
      }
      if (Starfocus === document.activeElement && this.starTwoCity1 === "") {
        this.starTwoList = true;
      }
    },

    // 目的城市2
    endTwoCity1() {
      let endCity = document.getElementById("endTwoCity");
      if (this.endTwoCity1 !== "") {
        this.EndTwoList = false;
        this.detectionCity();
      }
      if (endCity === document.activeElement && this.endTwoCity1 === "") {
        this.EndTwoList = true;
      }
    },

    // 获取国内出发城市
    startAirportParams(newVal) {
      console.log(newVal)
      this.starCity = newVal.code
      this.starCity1 = newVal.name
    },
    // 获取国内目的城市
    endAirportParams(newVal) {
      console.log(newVal)
      this.endCity = newVal.code
      this.endCity1 = newVal.name
    },
  },
  mounted() {
    this.getNoticeList()
    this.loadAllCity();
    this.loadAllInternationalCity();
  },
  created() {
    this.getAirlines();
    this.getInternationalAirlines();
  }
};
</script>


<style lang='less' scoped>
@import "./../../components/css/index.less";
.passenger-air {
  justify-content: flex-start !important;
  margin: 10px 0;
}
.select-box {
  height: 232px;
}
</style>
<style>
/* IE 浏览器 */
.scrollbar {
  /*三角箭头的颜色*/
  scrollbar-arrow-color: #fff;
  /*滚动条滑块按钮的颜色*/
  scrollbar-face-color: #0099dd;
  /*滚动条整体颜色*/
  scrollbar-highlight-color: #0099dd;
  /*滚动条阴影*/
  scrollbar-shadow-color: #0099dd;
  /*滚动条轨道颜色*/
  scrollbar-track-color: #0066ff;
  /*滚动条3d亮色阴影边框的外观颜色——左边和上边的阴影色*/
  scrollbar-3dlight-color: #0099dd;
  /*滚动条3d暗色阴影边框的外观颜色——右边和下边的阴影色*/
  scrollbar-darkshadow-color: #0099dd;
  /*滚动条基准颜色*/
  scrollbar-base-color: #0099dd;
}

/* chrome & safari 浏览器 */
/*滚动条整体部分,必须要设置*/
.scrollbar::-webkit-scrollbar {
  width: 3px;
  height: 2px;
  background-color: #0099ff;
}
/*滚动条的轨道*/
.scrollbar::-webkit-scrollbar-track {
  background-color: #ccc;
}
/*滚动条的滑块按钮*/
.scrollbar::-webkit-scrollbar-thumb {
  border-radius: 0;
  background-color: #0099ff;
  box-shadow: inset 0 0 5px #0099ff;
}
/*滚动条的上下两端的按钮*/
.scrollbar::-webkit-scrollbar-button {
  height: 0;
  background-color: #ccc;
}
</style>
